import {
  ResponseInnerMessage,
  FontsWhitelist,
  MessageData,
  BroadcastStatus,
  Placeholder,
  AriaLabel,
} from '@/hosted_fields/common/types';
import {Card, IDeal} from '@/hosted_fields/common/enums';
import {ComponentType} from '@/hosted_fields/common/base-types';
import BaseFactory from '@/hosted_fields/component/fields/base-factory-interface';
import Client from '@/hosted_fields/common/connection/client';
import {Styles, Locale} from '@/hosted_fields/common/types';

export default class ComponentFactory {
  static component: BaseFactory = null;
  static create(client: Client, data: MessageData): Promise<ResponseInnerMessage> {
    // assert data.name is not null;
    // TODO sanity checks
    return this._create(client, data).then((component: any) => {
      this.component = component;
      return this.component.create();
    });
  }

  static fetchData(): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.getValue());
  }

  static receiveStatus(data: BroadcastStatus): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.receiveStatus(data));
  }

  static focus(): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.focus());
  }

  static blur(): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.blur());
  }

  static clear(): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.clear());
  }

  static _create(client: Client, data: MessageData): Promise<BaseFactory> {
    switch (data.type) {
      case ComponentType.Card:
        switch (data.fieldType) {
          case Card.ComponentFieldType.Combined:
            return import('@/hosted_fields/component/fields/card-combined').then(
              (CardCombined) => new CardCombined.default(client, data)
            );
          case Card.ComponentFieldType.Number:
            return import('@/hosted_fields/component/fields/card-number').then(
              (CardNumber) => new CardNumber.default(client, data)
            );
          case Card.ComponentFieldType.CVV:
            return import('@/hosted_fields/component/fields/card-cvv').then(
              (CardCVV) => new CardCVV.default(client, data)
            );
          case Card.ComponentFieldType.Expiry:
            return import('@/hosted_fields/component/fields/card-expiry').then(
              (CardExpiry) => new CardExpiry.default(client, data)
            );
        }

      case ComponentType.IDeal:
        switch (data.fieldType) {
          case IDeal.ComponentFieldType.BankSelect:
            return import('@/hosted_fields/component/fields/ideal-bank-select').then(
              (BankSelect) => new BankSelect.default(client, data)
            );
          case IDeal.ComponentFieldType.BankList:
            return import('@/hosted_fields/component/fields/ideal-bank-list').then(
              (BankList) => new BankList.default(client, data)
            );
        }
    }

    throw new Error('factory not implemented');
  }

  static destroy(): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.destroy());
  }

  static validate(): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.validateField());
  }

  static updateFonts(data: FontsWhitelist): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updateFonts(data));
  }

  static updateStyles(data: Styles): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updateStyles(data));
  }

  static updatePlaceholder(data: Placeholder | string): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updatePlaceholder(data));
  }

  static updateAriaLabel(data: AriaLabel | string): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updateAriaLabel(data));
  }

  static updateIcon(data: boolean): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updateIcon(data));
  }

  static updateLocale(data: Locale): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updateLocale(data));
  }

  static updateIDealBankList(data: any): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.updateIDealBankList(data));
  }

  static iDealBankSelected(data: any): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.iDealBankSelected(data));
  }
  static selectTestCard(data: any): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.selectTestCard(data));
  }
  static configData(data: any): Promise<ResponseInnerMessage> {
    return Promise.resolve(this.component.configData(data));
  }
}
